import React, { useRef, useState, useEffect, useCallback, Suspense, useMemo } from "react";
import FormCreator from "../../components/forms/FormCreator";
import { useLazyGetAllDropDownsForMemberQuery, useLazyGetPDFQuery, useStoreBase64ImageMutation, useUploadPDFMutation } from "../../app/services/common/commonServiceApi";
import { viewIndividualMemberFormDropdownConfigs } from "./utils/setDropdownFields";
import { setAllDropDownFieldsBatch } from "../../utils/FormFields/FieldsSetting/SetFieldSetting";
import { useNavigate, useParams } from "react-router-dom";
import { handleFieldChange, } from "./utils/handleFieldChange";
import { useSendRenewalMailManuallyMutation, useLazyGetIndividualDetailsForUpgrademembershipbyIdQuery, useEditUpgradeMemberDetailsMutation } from "../../app/services/ViewIndividulaMember/ViewIndividualMemberServiceApi";
import DataLoader from "../../components/FinalMolGrid/ui/dataLoader/DataLoader";
import Buttons from "../../components/ui/button/Buttons";
import SwalAlert from "../../services/swalService/SwalService";
import { decryptAESID } from "../../utils/Encryption";
import { setFieldParameter } from "./utils/setEditFormField";
import { saveAs } from 'file-saver'
import ToastService from "../../services/toastService/ToastService";
import { EditViewIndividualMemberData } from "./data/EditViewIndividualMember.Data";
import { getAuditContext } from "../../lib/authenticationLibrary";

const EditViewUpgradeMemberForm = () => {
  const editViewIndividualMemberFormRef = useRef();
  const [editViewIndividualMemberForm, setEditViewIndividualMemberForm] = useState(EditViewIndividualMemberData);
  const navigate = useNavigate();
  const { memberId } = useParams();
  const editID = memberId ? decryptAESID(memberId, false) : 0;
  const { error, success, confirm } = SwalAlert();
  const audit = getAuditContext();
  const [uploadedFileName, setUploadedFileName] = useState({
    DisplayPhoto: "",
    displayPhotoEncFileName: "",
    resumeWorkExpFile: "",
    resumeWorkExpEncFileName: "",
    relevantDiplomasCertificatesFile: "",
    relevantDiplomasCertificatesEncFileName: "",
    detailedListAppRoleRespoFile: "",
    detailedListAppRoleRespoFileEncFileName: "",
    firstCharacterRefFile: "",
    firstCharacterRefEncFileName: "",
    secondCharacterRefFile: "",
    secondCharacterRefEncFileName: "",
    charaterRoleFile: "",
    charaterRoleFileEncFileName: "",
    ReinstatementFile: "",
    reinstatementFileEncryptedName: ""
  });

  const [uploadFile, { isSuccess: isFileSuccess, isLoading: isFileLoading, data: uploadFileResponse }] = useUploadPDFMutation();
  const [imageUpload, { isSuccess: isImageSuccess, isLoading: isImageLoading, data: uploadImgResponse }] = useStoreBase64ImageMutation();
  const [getAllDropDowns, { isLoading: dropdownIsLoading, isSuccess: isSuccess, data: allDropDownResponse }] = useLazyGetAllDropDownsForMemberQuery();
  // const [getIndividualDetails, { isLoading: getIndividualDetailsIsLoading, isSuccess: getIndividualDetailsIsSuccess, data: getIndividualDetailsResponse }] = useLazyGetIndividualDetailsbyIdQuery();
  const [getIndividualDetailsForUpgrademembership, { isLoading: getIndividualDetailsIsLoading, isSuccess: getIndividualDetailsIsSuccess, data: getIndividualDetailsResponse }] = useLazyGetIndividualDetailsForUpgrademembershipbyIdQuery();
  // const [saveMemberDetails, { isSuccess: saveMemberDetailsIsSuccess, isLoading: saveMemberDetailsIsLoading, data: saveMemberDetailsResponse }] = useEditIPASMemberDetailsMutation();
  const [saveUpgradeMemberDetails, { isSuccess: saveUpgradeMemberDetailsIsSuccess, isLoading: saveUpgradeMemberDetailsIsLoading, data: saveUpgradeMemberDetailsResponse }] = useEditUpgradeMemberDetailsMutation();
  const [getPDF, { isSuccess: isSuccessGetPDF, isLoading: isLoadingGetPDF, data: getPDFData }] = useLazyGetPDFQuery();
  const [sendRenewalMailManually, { isSuccess: isSendRenewalMailManuallySuccess, isLoading: isSendRenewalMailManuallyLoading, data: sendRenewalMailData }] = useSendRenewalMailManuallyMutation();
  const hideForNonStudent = [
    "Student Education Information"
  ]

  useEffect(() => {
    if (editID && editID > 0) {
      getAllDropDowns();
      getIndividualDetailsForUpgrademembership(editID);
    }
  }, [editID, getAllDropDowns, getIndividualDetailsForUpgrademembership]);

  useEffect(() => {
    if (!isLoadingGetPDF && isSuccessGetPDF && getPDFData) {
      saveAs(getPDFData.fileData, getPDFData.fileName);
    }
  }, [isLoadingGetPDF, isSuccessGetPDF, getPDFData]);

  useEffect(() => {
    if (!dropdownIsLoading && isSuccess && allDropDownResponse) {
      if (allDropDownResponse) {
        // Updates dropdown fields in the form based on the fetched data
        setAllDropDownFieldsBatch(EditViewIndividualMemberData, viewIndividualMemberFormDropdownConfigs, allDropDownResponse);
      }
    }
  }, [dropdownIsLoading, isSuccess, allDropDownResponse]);

  useEffect(() => {
    if (!saveUpgradeMemberDetailsIsLoading && saveUpgradeMemberDetailsIsSuccess && saveUpgradeMemberDetailsResponse) {
      if (saveUpgradeMemberDetailsResponse.keyId > 0) {
        success("Details updated successfully", "Success");
      }
    }
  }, [saveUpgradeMemberDetailsIsLoading, saveUpgradeMemberDetailsIsSuccess, saveUpgradeMemberDetailsResponse]);

  useEffect(() => {
    if (!isFileLoading && isFileSuccess && uploadFileResponse) {
      const storagePath = uploadFileResponse?.fileName?.split("\\")[1];
      setUploadResponseFileName(storagePath, uploadFileResponse?.uploadedFileName, uploadFileResponse?.fileName);
    }
  }, [isFileLoading, isFileSuccess, uploadFileResponse]);

  useEffect(() => {
    if (!getIndividualDetailsIsLoading && getIndividualDetailsIsSuccess && getIndividualDetailsResponse) {
      handleSetGetByIdMemberDetails(getIndividualDetailsResponse);
    }
  }, [getIndividualDetailsIsLoading, getIndividualDetailsIsSuccess, getIndividualDetailsResponse]);

  useEffect(() => {
    if (!isImageLoading && isImageSuccess && uploadImgResponse) {
      let storagePath = uploadImgResponse?.fileName?.split("\\")[1];

      if (storagePath === "DisplayPhoto") {
        storagePath = "DisplayPhoto";
      }

      setUploadResponseFileName(storagePath, uploadImgResponse?.uploadedFileName, uploadImgResponse?.fileName);

      ToastService.success("Image has been uploaded successfully !");
    }
  }, [isImageLoading, isImageSuccess, uploadImgResponse]);

  useEffect(() => {
    if (!isSendRenewalMailManuallyLoading && isSendRenewalMailManuallySuccess && sendRenewalMailData) {
      success("Renewal mail sent successfully", "Success");
    }
  }, [isSendRenewalMailManuallyLoading, isSendRenewalMailManuallySuccess, sendRenewalMailData])

  // useEffect(() => {
  //   if (getIndividualDetailsIsSuccess && getIndividualDetailsResponse) {
  //     setEditViewIndividualMemberForm(prevForm => {
  //       if (!prevForm || !prevForm.section) return prevForm;

  //       const updatedConfig = {
  //         ...prevForm,
  //         section: prevForm.section.map(section => ({
  //           ...section,
  //           fields: section.fields.map(fields => {
  //             if (fields?.fieldSetting?.formControltemplate?.props?.actionName === "Send Renewal Mail") {
  //               const shouldDisable = !(getIndividualDetailsResponse?.isUpgradeApplications === true && getIndividualDetailsResponse?.paymentstatus === 'Pending'
  //                 // && getIndividualDetailsResponse?.subscriptionEndDate === moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD')
  //               );
  //               if (shouldDisable) {
  //                 error(
  //                   "A Upgrade process is currently in progress. Please complete the renewal before proceeding with the upgrade.",
  //                   "Oops!"
  //                 );
  //               }
  //             }

  //             return fields;
  //           }),
  //         })),
  //       };

  //       return updatedConfig;
  //     });
  //   }
  // }, [getIndividualDetailsIsSuccess, getIndividualDetailsResponse]);

  const memoizedHandleFieldChange = (dataFieldName, updateFormData) => {
    if (dataFieldName === "DisplayPhoto") {
      handleImageUpload(updateFormData?.DisplayPhoto, "DisplayPhoto");
    }
    else if (["resumeWorkExpFile", "relevantDiplomasCertificatesFile", "detailedListAppRoleRespoFile", "firstCharacterRefFile", "secondCharacterRefFile"].includes(dataFieldName)) {
      handleFileUpload(dataFieldName, updateFormData[dataFieldName]);
    }
    else {
      handleFieldChange(
        dataFieldName,
        updateFormData,
        allDropDownResponse
      )
    }
  }

  // Update state with uploaded file response
  const setUploadResponseFileName = (fieldName, fileName, encFileName) => {
    const validFields = {
      resumeWorkExpFile: "resumeWorkExpEncFileName",
      relevantDiplomasCertificatesFile: "relevantDiplomasCertificatesEncFileName",
      detailedListAppRoleRespoFile: "detailedListAppRoleRespoFileEncFileName",
      firstCharacterRefFile: "firstCharacterRefEncFileName",
      secondCharacterRefFile: "secondCharacterRefEncFileName",
      charaterRoleFile: "charaterRoleFileEncFileName",
      DisplayPhoto: "displayPhotoEncFileName",
      ReinstatementFile: "reinstatementFileEncryptedName"
    };

    if (validFields[fieldName]) {
      setUploadedFileName((prevState) => ({
        ...prevState,
        [fieldName]: fileName,
        [validFields[fieldName]]: encFileName,
      }));
    }
  };

  const handleSetGetByIdMemberDetails = () => {
    const updatedFormData = setFieldParameter(editViewIndividualMemberForm, allDropDownResponse, getIndividualDetailsResponse);
    const accountStatusId = getIndividualDetailsResponse?.subscriptionStatusId;
    // if (accountStatusId === 1) {
    //   updatedFormData.section.forEach(section => {
    //     section.fields?.forEach(field => {
    //       if (field?.dataField === "isINSOLMembership") {
    //         field.fieldSetting.isDisable = true;
    //       }
    //     });
    //   });

    //   updatedFormData.section.forEach(section => {
    //     section.fields?.forEach(field => {
    //       if (field?.dataField === "reasonId") {
    //         field.fieldSetting.isDisable = true;
    //       }
    //     });
    //   });
    // }
    updatedFormData.section.forEach(section => {
      section.fields?.forEach(field => {
        if (field?.dataField === "yearsOfRIExp") {
          field.label = getIndividualDetailsResponse?.membershipType === 1
            ? "Years of R&I experience"
            : "Years of R&I experience (at least 7 years of approved practical experience)";
          field.Field_Name = "Years of R&I experience";
        }
      });
    });

    updatedFormData.section = updatedFormData.section.filter(
      (section) => !hideForNonStudent.includes(section.title)
    );

    setEditViewIndividualMemberForm((prevState) => ({
      ...prevState,
      updatedFormData
    }));

    setUploadedFileName((prevState) => ({
      ...prevState,
      resumeWorkExpFile: getIndividualDetailsResponse?.resumeUploadedName,
      resumeWorkExpEncFileName: getIndividualDetailsResponse?.resumeEncryptedName,
      relevantDiplomasCertificatesFile: getIndividualDetailsResponse?.diplomasCertificatesUploadedName,
      relevantDiplomasCertificatesEncFileName: getIndividualDetailsResponse?.diplomasCertificatesEncryptedName,
      detailedListAppRoleRespoFile: getIndividualDetailsResponse?.roleResponsibilitiesFileUploadedName,
      detailedListAppRoleRespoFileEncFileName: getIndividualDetailsResponse?.roleResponsibilitiesFileEncryptedName,
      firstCharacterRefFile: getIndividualDetailsResponse?.firstCharacterReferenceFileUploadedName,
      firstCharacterRefEncFileName: getIndividualDetailsResponse?.firstCharacterReferenceFileEncryptedName,
      secondCharacterRefFile: getIndividualDetailsResponse?.secondCharacterReferenceFileUploadedName,
      secondCharacterRefEncFileName: getIndividualDetailsResponse?.secondCharacterReferenceFileEncryptedName,
      displayPhotoEncFileName: getIndividualDetailsResponse?.displayPhotoEncryptedName,
      ReinstatementFile: getIndividualDetailsResponse?.reinstatementFileUploadedName,
      reinstatementFileEncryptedName: getIndividualDetailsResponse?.reinstatementFileEncryptedName,
    }));
  };

  // Handle file uploads
  const handleFileUpload = (fieldName, fileInfo) => {
    const formData = new FormData();
    formData.append("file", fileInfo?.file);
    formData.append("storagePath", fieldName);
    uploadFile(formData);
  };

  const handleImageUpload = useCallback((fileDetails, storagePath) => {
    const request = {
      fileName: fileDetails?.fileName,
      fileStr: fileDetails?.base64Data,
      storagePath: storagePath,
    };
    imageUpload(request);
  }, [imageUpload]);



  const handleSave = () => {
    const individualFieldData = editViewIndividualMemberFormRef?.current?.getFormData();
    if (!individualFieldData || Object.keys(individualFieldData).length === 0) {
      error("Please fill all mandatory fields", "Error")
      return;
    }
    const request = {
      IPASMemberId: editID,
      MembershipType: getIndividualDetailsResponse?.membershipType || null,
      IsINSOLMembership: individualFieldData?.isINSOLMembership === "no" ? false : true || null,
      INSOLMembershipReasonId: individualFieldData?.isINSOLMembership === "no" ? individualFieldData?.reasonId?.value || individualFieldData?.reasonId : null,
      FirstName: individualFieldData?.firstName || null,
      SalutationId: individualFieldData?.salutationId?.value || individualFieldData?.salutationId,
      LastName: individualFieldData?.lastName || null,
      DisplayName: individualFieldData?.displayName || null,
      DisplayPhotoUploadedName: uploadImgResponse?.uploadedFileName || getIndividualDetailsResponse?.displayPhotoUploadedName,
      DisplayPhotoEncryptedName: uploadImgResponse?.fileName || getIndividualDetailsResponse?.displayPhotoEncryptedName,
      IsGenderMale: individualFieldData?.gender === "male" ? true : false || null,
      DateOfBirth: individualFieldData?.dateofBirth || null,
      PlaceOfBirthId: individualFieldData?.placeofBirth?.value || individualFieldData?.placeofBirth,
      NationalityId: individualFieldData?.nationalityId?.value || individualFieldData?.nationalityId,
      NRIC: individualFieldData?.last4DigitsofNRIC,
      Workpass: individualFieldData?.workpass,
      AddressLine1: individualFieldData?.mailingAddressLine1,
      AddressLine2: individualFieldData?.mailingAddressLine2,
      AddressLine3: individualFieldData?.mailingAddressLine3,
      CountryId: individualFieldData?.countryId?.value || individualFieldData?.countryId,
      PostalCode: individualFieldData?.postalCode,
      EmailAddress: individualFieldData?.emailAddress,
      Mobile: individualFieldData?.mobile || null,
      HighestQualificationAttained: individualFieldData?.highestQualificationId?.value || individualFieldData?.highestQualificationId,
      OtherEducationInformation: individualFieldData?.highestQualificationOthers || null,
      DegreeExaminationOrEquivalent: individualFieldData?.academicDegree,
      AwardingBody: individualFieldData?.awardingBody,
      OtherQualification: individualFieldData?.otherQualifications,
      IsCurrentlyEmployed: individualFieldData?.currentlyEmployed === "yes" ? true : false || null,
      OrganisationOrCompany: individualFieldData?.currentlyEmployed === "yes" ? individualFieldData?.organisationCompany : null,
      JobTitle: individualFieldData?.currentlyEmployed === "yes" ? individualFieldData?.jobTitle : null,
      JobRoleId: individualFieldData?.currentlyEmployed === "yes" ? individualFieldData?.jobRoleId?.value || individualFieldData?.jobRoleId : null,
      Bio: individualFieldData?.bio,
      OrganisationAddressLine1: individualFieldData?.currentlyEmployed === "yes" ? individualFieldData?.organisationAddressLine1 : null,
      OrganisationAddressLine2: individualFieldData?.currentlyEmployed === "yes" ? individualFieldData?.organisationAddressLine2 : null,
      OrganisationAddressLine3: individualFieldData?.currentlyEmployed === "yes" ? individualFieldData?.organisationAddressLine3 : null,
      EmploymentCountryId: individualFieldData?.currentlyEmployed === "yes" ? individualFieldData?.empCountryId?.value || individualFieldData?.empCountryId : null,
      EmploymentPostalCode: individualFieldData?.currentlyEmployed === "yes" ? individualFieldData?.empPostalCode : null,
      EmploymentEmailAddress: individualFieldData?.currentlyEmployed === "yes" ? individualFieldData?.empEmailAddress : null,
      EmploymentMobile: individualFieldData?.currentlyEmployed === "yes" ? individualFieldData?.empMobile : null,
      LinkedIn: individualFieldData?.linkdein,
      AccountantRegisteredWithACRA: individualFieldData?.isPublicAccountantRegACRA,
      CharteredAccountant: individualFieldData?.isCharteredAccountant,
      AdvocateAndSolicitor: individualFieldData?.isAdvocateAndSolicater,
      IsOtherProfessionalInformation: individualFieldData?.isOtherProfessional,
      OtherProfessionalInformation: individualFieldData?.isOtherProfessional ? individualFieldData?.isOtherProfessionalReason : null,
      IsCriminalOffence: individualFieldData?.iscriminaloffence === "yes" || false,
      CriminalOffenceDetails: individualFieldData?.criminaloffenceMoreDetails,
      IsAdjudgedBankrupt: individualFieldData?.isBenifitsOfYourCreditors === "yes" || false,
      AdjudgedBankruptDetails: individualFieldData?.benifitsOfYourCreditorsMoreDetails,
      ResumeUploadedName: uploadedFileName?.resumeWorkExpFile || null,
      ResumeEncryptedName: uploadedFileName?.resumeWorkExpEncFileName || null,
      DiplomasCertificatesUploadedName: uploadedFileName?.relevantDiplomasCertificatesFile || null,
      DiplomasCertificatesEncryptedName: uploadedFileName?.relevantDiplomasCertificatesEncFileName || null,
      RoleResponsibilitiesFileUploadedName: uploadedFileName?.detailedListAppRoleRespoFile || null,
      RoleResponsibilitiesFileEncryptedName: uploadedFileName?.detailedListAppRoleRespoFileEncFileName || null,
      YearsOfRIExperience: individualFieldData.yearsOfRIExp,
      FirstCharacterReferenceFileUploadedName: uploadedFileName?.firstCharacterRefFile || null,
      FirstCharacterReferenceFileEncryptedName: uploadedFileName?.firstCharacterRefEncFileName || null,
      SecondCharacterReferenceFileUploadedName: uploadedFileName?.secondCharacterRefFile || null,
      SecondCharacterReferenceFileEncryptedName: uploadedFileName?.secondCharacterRefEncFileName || null,
      SubscribeToMailingList: individualFieldData.isSubscribeToMailList || null,
      UpdatedBy: audit.adminUserId,
      UpdatedAppId: audit.appId,
    }
    saveUpgradeMemberDetails(request);
  }

  const handleSendRenewalMail = () => {
    if (
      getIndividualDetailsResponse?.isUpgradeApplications === true &&
      getIndividualDetailsResponse?.paymentstatus === 'Pending'
    ) {
      error(
        "An upgrade process is currently in progress. Please complete the upgrade before proceeding with the renewal.",
        "Oops!"
      );
    } else {
      confirm('Confirm send Mail', `Are you sure you want to send renewal mail`, 'Yes', 'NO').then((res) => {
        if (!res)
          return;
        const individualFieldData = editViewIndividualMemberFormRef.current.getFormData();

        const request = {
          IPASMemberId: Number(editID),
          ApplicationTypeId: getIndividualDetailsResponse?.membershipType,
        };

        sendRenewalMailManually(request);
      })

    }
  };


  const handleActionChange = (action, dataField) => {
    if (action === "DOWNLOAD") {
      handleDownload(dataField)
    }
    else if (action === "Send Renewal Mail") {
      handleSendRenewalMail();
    }
  }
  const handleDownload = (dataField) => {
    const fetchEncFileName = {
      resumeWorkExpFile: "resumeWorkExpEncFileName",
      relevantDiplomasCertificatesFile: "relevantDiplomasCertificatesEncFileName",
      detailedListAppRoleRespoFile: "detailedListAppRoleRespoFileEncFileName",
      firstCharacterRefFile: "firstCharacterRefEncFileName",
      secondCharacterRefFile: "secondCharacterRefEncFileName",
      DisplayPhoto: "displayPhotoEncFileName",
      ReinstatementFile: "reinstatementFileEncryptedName"
    };
    let fileName = fetchEncFileName[dataField];

    if (uploadedFileName?.[fileName]?.includes('.png') || uploadedFileName?.[fileName]?.includes('Images\\')) {

      let request = {
        type: dataField,
        fileName: uploadedFileName?.[fileName]
      }
      getPDF(request)
    }
    else {
      let request = {
        type: dataField,
        fileName: uploadedFileName?.[fileName],
      }
      getPDF(request)
    }
  }
  const handleBack = () => { navigate(-1); }
  const memoizedFormConfig = useMemo(() => editViewIndividualMemberForm, [editViewIndividualMemberForm]);
  const shouldDisable = false

  return (
    <div className="membership-application">
      <div className={shouldDisable ? "vertical-form" : "vertical-form hide-btn-sec "}>
        {!getIndividualDetailsIsLoading && isSuccess && (
          <Suspense fallback={<DataLoader />}>
            <FormCreator
              config={memoizedFormConfig}
              ref={editViewIndividualMemberFormRef}
              key={false}
              onColumnChange={memoizedHandleFieldChange}
              onActionChange={handleActionChange}
            />
          </Suspense>
        )
        }
      </div>
      <div className="d-flex justify-content-between">
        <div>
          <Buttons
            onClick={handleBack}
            buttonText={"Back"}
            buttonTypeClassName="back-btn btn"
            isLoading={false}
          />
        </div>
        <div>
          <Buttons
            onClick={handleSave}
            buttonText={"Save"}
            buttonTypeClassName="theme-btn btn mt-auto"
            isLoading={false}
          />
        </div>
      </div>
    </div>
  );
}

export default EditViewUpgradeMemberForm